import { Invoice, InvoiceSource, InvoiceStatus } from '@/features/admin/billing/types';

export const mockInvoices: Invoice[] = [
  {
    id: 'INV_mock_1',
    number: 'FAC-2025-00001',
    companyName: 'Client A',
    companyEmail: 'contact@client-a.test',

    status: InvoiceStatus.DRAFT,
    source: InvoiceSource.BILLING_FORM,
    currency: 'EUR',
    lines: [
      {
        id: 'L1',
        label: 'Prestation conseil — Octobre 2025',
        quantity: 10,
        unitPrice: 650,
        vatRate: 0.2,
        totalExVat: 6500,
      },
    ],
    subtotal: 6500,
    vatAmount: 1300,
    total: 7800,
    meta: { paymentDelayDays: 30, companyAddress: '10 rue de Paris, 75001 Paris' },
    createdAt: '2025-03-01T10:00:00.000Z',
    updatedAt: '2025-03-01T10:00:00.000Z',
  },
  {
    id: 'INV_mock_2',
    number: 'FAC-2025-00002',
    companyName: 'Client B',
    companyEmail: 'contact@client-b.test',
    status: InvoiceStatus.INVOICED,
    source: InvoiceSource.BILLING_FORM,
    currency: 'EUR',
    period: '2025-10',
    lines: [
      {
        id: 'L2a',
        label: 'Développement React',
        quantity: 15,
        unitPrice: 600,
        vatRate: 0.2,
        totalExVat: 9000,
      },
      {
        id: 'L2b',
        label: 'Formation équipe',
        quantity: 2,
        unitPrice: 800,
        vatRate: 0.2,
        totalExVat: 1600,
      },
    ],
    subtotal: 10600,
    vatAmount: 2120,
    total: 12720,
    meta: { paymentDelayDays: 45, companyAddress: '20 avenue de Lyon, 69000 Lyon' },
    createdAt: '2025-09-15T09:00:00.000Z',
    updatedAt: '2025-10-20T14:00:00.000Z',
  },
  {
    id: 'INV_mock_3',
    companyName: 'Globex',
    status: InvoiceStatus.SENT,
    source: InvoiceSource.AUTO_FROM_TIMESHEET,
    currency: 'EUR',
    number: 'FAC-2025-00003',
    period: '2025-10',
    issuedAt: '2025-11-01T10:00:00.000Z',
    pdfUrl: 'https://www.africau.edu/images/default/sample.pdf', // Mock URL S3
    lines: [
      {
        id: 'L3',
        label: 'Prestation 2025-10 — Alice Martin',
        quantity: 12,
        unitPrice: 650,
        vatRate: 0.2,
        totalExVat: 7800,
      },
    ],
    subtotal: 7800,
    vatAmount: 1560,
    total: 9360,
    meta: { timesheetId: 'TS-2025-10-USER42', consultantName: 'Alice Martin' },
    createdAt: '2025-10-15T08:00:00.000Z',
    updatedAt: '2025-11-01T10:00:00.000Z',
  },
];
